import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const CWWeeklyWorkplace = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4' style={{ }}>
            <Row className=''>
                <Col md='12' lg='7' className=''>
                    <div className='pe-md-4'>
                        <div className=''>
                            <div className='fs-ss-24 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                                *FREE Weekly Workplace Covid-19 Testing (Nursing Homes, Daycare Centers)
                            </div>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic', letterSpacing:'0.5px'}}>
                                Onsite-Offsite Testing Facility
                            </div>
                        </div>

                        <div className='py-3 pe-md-5'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            Are you going to continue working during Covid-19 and want to keep your workplace virus-free? If you desire an infection-free environment, COVID-19 testing for your employees and teams is required. The health and well-being of your staff are crucial and to help you manage a safe working environment, United Lab Care provides free weekly workplace Covid-19 testing services on-site or off-site for nursing homes, daycare centers, and communities.                    
                            </div>
                        </div>

                        <div className='pt-2 flex-center1'>
                        <Link to='/book-covid-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    SCHEDULE YOUR COVID TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
                <Col md='12' lg='5' className=''>
                    <div className='flex-center pt-md-5 pt-lg-0 pt-4'>
                        <img src='covid-workplace/Workplace-Covid-Testing-img1-v1.webp' alt='' className='img-w5-2' width='%' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default CWWeeklyWorkplace